import React from "react"
import classes from "./ResultSet.module.css"
import { useTranslation } from "react-i18next"

const ResultSet = props => {
    const { t } = useTranslation()

    if (props.results.length === 0) return null

    return (
        <div className={classes.Wrapper}>
            <h2>{t("translation:LayoutMsg.Cmn_Menu_00.L_BtnMap_06-T_Text_00")}</h2>
            <div className={classes.ShopWrapper}>{props.results[0]}</div>
            <h2>{t("translation:LayoutMsg.Cmn_Menu_00.L_BtnMap_07-T_Text_00")}</h2>
            <div className={classes.ShopWrapper}>{props.results[1]}</div>
            <h2>{t("translation:LayoutMsg.Cmn_Menu_00.L_BtnMap_08-T_Text_00")}</h2>
            <div className={classes.ShopWrapper}>{props.results[2]}</div>
            <h2>{t("translation:LayoutMsg.Cmn_Menu_00.L_BtnMap_09-T_Text_00")}</h2>
            <div className={classes.ShopWrapper}>{props.results[3]}</div>
        </div>
    )
}

export default React.memo(ResultSet)
